import { createService } from '@/helpers/hasura'
import gql from 'graphql-tag'
import { pickDeep } from '@/helpers'
import _ from 'lodash'

const output = `
    key
    options
`

const allowedFields = [
  'key',
  {
    options: ['vat_rates']
  }
]

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'app_preference',
    primaryKey: ['key'],
    defaultPageSize: -1,
    defaultOrderBy: [],
    defaultSearchBy: null,
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: '',
    allowedFields
  })

  return {
    ...service,
    fetchOption: async (key, option) => {
      if (!key) throw new Error('key is undefined')
      if (!option) throw new Error('option is undefined')
      const query = gql`
        query($key: String!, $path: String!) {
            preference: app_preference_by_pk(key: $key){ ${option}: options(path: $path) }
        }
      `

      const { data } = await client.query({
        fetchPolicy: 'no-cache',
        query,
        variables: {
          key,
          path: option
        }
      })

      return data.preference[option]
    },
    updateOption: async (key, option, value) => {
      let pref = await service.fetch({ key })
      if (!pref) pref = service.create({ key })

      const payload = {}
      payload[option] = value

      const mutation = gql`
        mutation ($key: String!, $payload: jsonb) {
          update_app_preference_by_pk(
            pk_columns: { key: $key }
            _append: { options: $payload }
          ) {
            options
          }
        }
      `

      const {
        data: {
          update_app_preference_by_pk: { options }
        }
      } = await client.mutate({
        mutation,
        variables: {
          key,
          payload
        }
      })

      return options
    }
  }
}
